// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2rsPV","options":"AnswerScale_options__353Oz","selected":"AnswerScale_selected__1aYDa"};